// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "assets/css/" + chunkId + "." + {"22":"7a1bff3b","220":"d3577d6b","362":"581cafc3","513":"a00c0c1b","937":"5ec10476","951":"1711ec41"}[chunkId] + ".css";
};